module.exports = __webpack_public_path__ + "img/icon_header_views_setting@2x.87d0bdf1.png";